// index.js or main file
import './suppressResizeObserverLoopError';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Login from './pages/login/login';
import AdminRedirect from './adminRedirect/admin';
import Admin from './admin/admin';
import Home from './admin/pages/home/home';
import Rules from './admin/pages/rules/rules';
import { Provider } from 'react-redux';
import { store } from './admin/store';
import LoginPage from './admin/pages/login/login';
import Leaderboard from './pages/leaderboard/Leaderboard';
import USER from './pages/dddUI/user';
import ThemeUpdate from './admin/pages/themeupdate/themeupdate';
import ConfigureGameSettings from './pages/ConfigureGameSettings/ConfigureGameSettings';
import UserRole from './pages/User/User';
import ManagerDashboard from './pages/ManagerDashboard/ManagerDashboard';
import ManagerCards from './pages/ManagerDashboard/ManagerCards';
import UserGame from './pages/UserGame/UserGame';
import JoinedLobby from './pages/JoinedLobby/JoinedLobby';
import TabooGame from './pages/TabooGame/TabooGame';
import SelectNextPlayer from './pages/SelectNextPlayer/SelectNextPlayer';
import RedirectToGame from './pages/RedirectToGame';





function App() {
  // usePageBackground();

   return (
    <Provider store={store}>
      <Routes>
        {/* Admin routes (no DDDUI wrapper) */}
        <Route path="/admin">
          <Route index element={<Admin><Home /></Admin>} />
          <Route path="rules" element={<Admin><Rules /></Admin>} />
          <Route path="themeupdate" element={<Admin><ThemeUpdate /></Admin>} />
          <Route path="superadmin" element={<LoginPage/>} />
        </Route>

        {/* Public routes wrapped with DDDUI */}
        <Route path="*" element={
          <USER>
            <Routes>
              <Route index element={<Login />} />
              <Route path="/login" element={<Login />} />
              <Route path="/configure-game-settings" element={<ConfigureGameSettings />} />
              <Route path="/user" element={<UserRole />} />
              <Route path="/manager-dashboard" element={<ManagerDashboard />} />
              <Route path="/manager-cards" element={<ManagerCards />} />
              <Route path="/usergame" element={<UserGame />} />
              <Route path="/leaderboard" element={<Leaderboard/>} />
              <Route path="/AdminRedirect" element={<AdminRedirect />} />
              <Route path="/joinedLobby" element={<JoinedLobby />} />
              <Route path="/game" element={<TabooGame />} />
              <Route path="/select-next-player" element={<SelectNextPlayer />} />
              <Route path="/selectDrawer" element={<RedirectToGame />} />
              <Route path="/yourTurn" element={<RedirectToGame />} />
              <Route path="/draw" element={<RedirectToGame />} />
            </Routes>
          </USER>
        } />
      </Routes>
    </Provider>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

// Performance reporting
reportWebVitals();
